module.exports = __webpack_public_path__ + "img/logo.9678b6dd.png";